<template>
    <main id="mainCtrl">
        <CarryOverDialog ref="dialog" :urlsFrontend="urlsFrontend"/>
        <div class="nav-tabs-custom">
            <button v-if="canModify"
                    @click="showCarryOverModal"
                    style="width: min-content;float: right; margin-top: 5px;">
                Перенести
            </button>
            <ul class="nav nav-tabs" v-cloak>
                <li :class="{'active': defaultFilter.type === 'new'}" @click.stop.prevent="load('new')" id="tabNew"><a
                    href="#">Новые</a></li>
                <li :class="{'active': defaultFilter.type === 'published'}" @click.stop.prevent="load('published')"
                    id="tabPublished"><a href="#">Опубликованные</a></li>
                <li :class="{'active': defaultFilter.type === 'unpublished'}" @click.stop.prevent="load('unpublished')"
                    id="tabUnpublished"><a href="#">Неопубликованные</a></li>
            </ul>
        </div>
        <v-table
            id="mainTbl"
            :default-filter="defaultFilter"
            request-uri="reviews/getList"
            pagesize="50"
            ref="table"
            :lazycount="true"
            :show-eye="false"
            @updated="setTextHeight"
        >
            <template v-slot:header>
                <v-tr>
                    <v-th name="revieweeName">
                        Врач/Клиника
                    </v-th>
                    <v-th name="authorName">
                        ФИО пациента
                    </v-th>
                    <v-th name="info">
                        Текст отзыва
                    </v-th>
                    <v-th name="moderatorId">
                        Проверил
                    </v-th>
                    <v-th name="authorPhone">
                        Телефон автора
                    </v-th>
                </v-tr>
                <v-tr>
                    <v-th name="revieweeName" :debounce="true" v-slot="{filter}">
                        <v-input v-model="filter.value" />
                    </v-th>

                    <v-th name="authorName" :debounce="true" v-slot="{filter}">
                        <v-input v-model="filter.value" />
                    </v-th>

                    <v-th name="info" :debounce="true" v-slot="{filter}">
                        <v-input v-model="filter.value" />
                    </v-th>

                    <v-th name="moderatorId" v-slot="{filter}">
                        <v-select
                            v-model="filter.value"
                            :options='[
                                {
                                    value: "",
                                    text: "\u00a0"
                                },
                                ...userOptions.map(({text, value}) => {
                                    return {
                                        text,
                                        value
                                    }
                                })
                            ]'
                        ></v-select>
                    </v-th>
                    <v-th name="authorPhone" v-slot="{filter}">
                        <v-input v-model="filter.value" />
                    </v-th>
                </v-tr>
            </template>

            <template v-slot:row="{ item, index }">
                <v-tr>
                    <v-td>
                            <FormRow :key="index" :item="item"
                                     :status="defaultFilter.type"
                                     :can-modify="canModify"
                                     :can-delete="canDelete"
                                 @update-table="update">
                            <template v-slot:legend>
                                <a :href="`${urlsFrontend}/${item.reviewee.city}/${item.reviewee_type.toLowerCase()}/${item.reviewee.url}`" target="_blank" v-tooltip="`${urlsFrontend}<br/>/${item.reviewee.city}/${item.reviewee_type.toLowerCase()}/${item.reviewee.url}`">
                                  {{item.reviewee.name}}
                                </a>
                            </template>
                        </FormRow>
                    </v-td>
                </v-tr>
            </template>
        </v-table>
    </main>
</template>

<script>
import FormRow from "./FormRow";
import CarryOverDialog from "./carryOverDialog/Dialog";
import NewPublishedUnpublishedSwitcher from "@mixins/NewPublishedUnpublishedSwitcher";
export default {
    props: {
        userOptions: {
            type: Array,
            required: true
        },
        urlsFrontend: {
            type: String,
            required: true
        }
    },
    components: {
        FormRow,
        CarryOverDialog,
    },
    mixins: [NewPublishedUnpublishedSwitcher],
    methods: {
        showCarryOverModal: function () {
            this.$refs.dialog.show();
        },

        update: function (data, btn = null) {
            this.$bus.fire('updateMenu');
            this.$refs.table.update();
        },

        setTextHeight() {
            setTimeout(() => {
                document.querySelectorAll('.positiveText').forEach(el => {
                    el.dispatchEvent(new Event('blur', { bubbles: true }));
                    el.style.height = '45px';
                    el.style.height = 5 + el.scrollHeight + 'px';
                })
                document.querySelectorAll('.negativeText').forEach(el => {
                    el.dispatchEvent(new Event('blur', { bubbles: true }));
                    el.style.height = '45px';
                    el.style.height = 5 + el.scrollHeight + 'px';
                })
                document.querySelectorAll('.commonText').forEach(el => {
                    el.dispatchEvent(new Event('blur', { bubbles: true }));
                    el.style.height = '45px';
                    el.style.height = 5 + el.scrollHeight + 'px';
                })
            }, 100)
        }
    },

    computed: {
        canModify () {
            return this.$can('admin.moderation.reviews.update');
        },
        canDelete () {
            return this.$can('admin.moderation.reviews.delete');
        }
    },
}
</script>

<style>
    main#mainCtrl #mainTbl .vuetable > .inner > table:nth-child(2) > tbody > tr {
        background-color: rgba(255, 255, 255, 0.5);
    }
</style>
